"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeeCoefficientInPercentage = void 0;
const roundToDecimalPlaces_1 = require("../roundToDecimalPlaces");
/**
 *
 * @param feeCoefficient
 * @returns 1 - feeCoefficient in percentage with 1 decimal place (e.g. 0.1 => 90.0)
 */
const getFeeCoefficientInPercentage = (feeCoefficient) => {
    return (0, roundToDecimalPlaces_1.roundToDecimalPlaces)((1 - feeCoefficient) * 100, 1);
};
exports.getFeeCoefficientInPercentage = getFeeCoefficientInPercentage;
//# sourceMappingURL=getFeeCoefficientInPercentage.js.map